import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/lib/toast"
import { CompanyFormData } from "@/schemas/admin/companySchema";

export const useCreateCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CompanyFormData) => {
      console.log("Criando empresa:", data);

      // 1. Criar empresa
      const { data: empresa, error: empresaError } = await supabase
        .from('empresas')
        .insert({
          razao_social: data.razao_social,
          nome_fantasia: data.nome_fantasia,
          cnpj: data.cnpj,
          area_atuacao: data.area_atuacao,
          ativo: data.ativo,
          rua: data.rua,
          cidade: data.cidade,
          uf: data.uf,
          cep: data.cep,
        })
        .select()
        .single();

      if (empresaError) {
        console.error("Erro ao criar empresa:", empresaError);
        throw new Error(empresaError.message);
      }

      console.log("Empresa criada:", empresa);

      // 2. Criar usuário admin via Edge Function
      const { data: adminData, error: adminError } = await supabase.functions.invoke('create-company-admin', {
        body: {
          email: data.admin_email,
          password: data.admin_senha,
          name: data.admin_nome,
          empresa_id: empresa.id,
        },
      });

      if (adminError) {
        console.error("Erro ao criar usuário administrador:", adminError);
        throw new Error(adminError.message || "Erro ao criar usuário administrador");
      }

      if (!adminData || adminData.error) {
        console.error("Erro retornado pela Edge Function:", adminData?.error);
        throw new Error(adminData?.error || "Erro ao criar usuário administrador");
      }

      console.log("Usuário administrador criado com sucesso:", adminData.user_id);

      return empresa;
    },
    onSuccess: () => {
      toast.success("Empresa criada com sucesso!");
      queryClient.invalidateQueries({ queryKey: ["admin-companies"] });
    },
    onError: (error: Error) => {
      console.error("Erro ao criar empresa:", error);
      toast.error(`Erro ao criar empresa: ${error.message}`);
    },
  });
};
